import { z } from "zod";
import { customErrorMap, myPreProcess } from '../shared/validation/zod';


z.setErrorMap(customErrorMap);

export const ItemCustomDataSchema = z.object({

    // required
    id: z.number(),
    business_id: z.number(),
    item_id: z.number(),
    field_index: z.number(),
    field_id: z.number().nullable(),

    created_at: z.string(),
    updated_at: z.string(),


    // nullable
    field_value: z.string().nullable(),

});

export const ItemCustomDataFormSchema = z.object({

    // optional in create
    id: z.number().optional(),
    business_id: z.number().optional(),
    item_id: z.number().optional(),
    field_id: z.number().nullish(),

    created_at: z.string().optional(),
    updated_at: z.string().optional(),

    // required
    field_index: z.number(),

    
    // optional nullable fields
    field_value: z.preprocess((val) => myPreProcess(val), z.string().nullable()),

});

export const ItemCustomDataSearchSchema = z.object({

    field_index: z.preprocess((val) => myPreProcess(val, Number(val)), z.number().nullish()),
    field_value: z.preprocess((val) => myPreProcess(val), z.string().nullish()),
});

export type ItemCustomData = z.infer<typeof ItemCustomDataSchema>
export type ItemCustomDataForm = z.infer<typeof ItemCustomDataFormSchema>
export type ItemCustomDataSearch = z.infer<typeof ItemCustomDataSearchSchema>
